var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.998px",
    height: "15.997px",
    viewBox: "276.5 -55.007 15.998 15.997",
    enableBackground: "new 276.5 -55.007 15.998 15.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e6c63",
    d: "M283.208-40.154c-0.109-0.007-0.22-0.002-0.329-0.003 c-1.27,0-2.538,0.006-3.807-0.002c-0.932-0.006-1.452-0.537-1.453-1.475c-0.003-3.579-0.002-7.158,0-10.736 c0-0.961,0.518-1.485,1.475-1.49c1.281-0.006,2.563-0.001,3.843-0.002c0.122,0,0.245,0.004,0.365-0.012 c0.312-0.041,0.49-0.237,0.502-0.542c0.011-0.31-0.173-0.505-0.469-0.575c-0.093-0.022-0.194-0.015-0.291-0.015 c-1.33-0.001-2.66-0.004-3.99,0c-1.517,0.005-2.55,1.05-2.552,2.583c-0.003,1.801-0.001,3.604-0.001,5.405 c0,1.814-0.003,3.628,0.001,5.442c0.003,1.505,1.042,2.556,2.536,2.562c1.342,0.005,2.685,0.001,4.026,0.001 c0.049,0,0.099,0.002,0.146-0.001c0.354-0.025,0.6-0.261,0.6-0.575C283.811-39.901,283.568-40.13,283.208-40.154z M292.231-47.749 c-1.171-1.189-2.346-2.375-3.522-3.56c-0.076-0.077-0.159-0.164-0.256-0.202c-0.265-0.104-0.513-0.061-0.683,0.186 c-0.189,0.275-0.13,0.539,0.095,0.767c0.81,0.822,1.623,1.64,2.431,2.464c0.079,0.081,0.205,0.135,0.207,0.318h-0.397 c-3.136,0-6.272,0-9.408,0c-0.135,0-0.271-0.006-0.402,0.012c-0.294,0.039-0.464,0.226-0.485,0.515 c-0.022,0.313,0.151,0.516,0.445,0.591c0.127,0.033,0.267,0.019,0.4,0.019c3.136,0,6.272,0,9.409,0h0.507 c-0.939,0.949-1.804,1.818-2.663,2.692c-0.304,0.309-0.328,0.625-0.085,0.878c0.236,0.248,0.578,0.228,0.87-0.066 c1.185-1.193,2.367-2.388,3.547-3.587C292.587-47.074,292.583-47.391,292.231-47.749z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit01);
export default __webpack_public_path__ + "static/media/exit-01.91507884b58d70955e8d9fc0c379c193.svg";
export { ForwardRef as ReactComponent };